import script from "./CallControls.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallControls.vue?vue&type=script&lang=ts&setup=true"

import "./CallControls.vue?vue&type=style&index=0&id=3241b35e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3241b35e"]])

export default __exports__